<template>
    <div :class="$attrs.class">
        <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
        <select :id="id" ref="input" v-model="selected" :multiple="multiple" v-bind="{ ...$attrs, class: null }"
                class="form-select" :class="{ error: error }">
            <slot/>
        </select>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
import {v4 as uuid} from 'uuid'

export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `select-input-${uuid()}`
            },
        },
        error: String,
        label: String,
        modelValue: [String, Number, Boolean, Array],
        multiple: Boolean
    },
    emits: ['update:modelValue'],
    data() {
        return {
            selected: this.modelValue,
        }
    },
    watch: {
        selected(selected) {
            this.$emit('update:modelValue', selected);
        },
        modelValue(newValue) {
            if (JSON.stringify(this.selected) !== JSON.stringify(newValue)) {
                this.selected = newValue;
            }
        }
    },
    methods: {
        focus() {
            this.$refs.input.focus();
        },
        select() {
            this.$refs.input.select();
        },
    },
}
</script>
